import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom';

import { getDriver } from '../../../apis/queries';
import Loader from '../../../components/Loader';
import Header from '../../../widgets/Header';
import DetailNotFound from '../../DetailNotFound';
import DriverDetailForm from './DriverDetailForm';

const EditDriverButton = ({
  isEditMode,
  isEditFormSubmitting,
  ...props
}: {
  isEditMode: boolean;
  isEditFormSubmitting: boolean;
  onClick: () => void;
}) => {
  return (
    <Button disabled={isEditFormSubmitting} {...props}>
      {' '}
      {isEditMode ? 'View Mode' : 'Edit Mode'}
    </Button>
  );
};

const DriverDetail = () => {
  const { id } = useParams();

  if (!id) {
    return <DetailNotFound />;
  }

  return <DriverDetailContent id={id} />;
};

const DriverDetailContent = ({ id }: { id: string }) => {
  const DRIVER_ID_QUERY_KEY = ['drivers', { id }];
  const { data, isLoading } = useQuery({ queryKey: DRIVER_ID_QUERY_KEY, queryFn: () => getDriver(id), enabled: !!id });
  const [isEditMode, setIsEditMode] = useState(false);
  const [isEditFormSubmitting, setEditFormSubmitting] = useState(false);

  const driver = data?.data;

  if (isLoading) {
    return <Loader fullscreen />;
  }

  const onEditButtonClicked = () => {
    setIsEditMode(!isEditMode);
  };

  const onEditFormSubmit = (loading: boolean) => {
    setEditFormSubmitting(loading);
  };

  if (!driver) {
    return <DetailNotFound />;
  }

  return (
    <div className="main-content">
      <Header
        title={driver?.name}
        isDetailPage
        headerButton={
          <EditDriverButton
            isEditFormSubmitting={isEditFormSubmitting}
            isEditMode={isEditMode}
            onClick={onEditButtonClicked}
          />
        }
      />
      <Container fluid>
        <Row className="justify-content-center">
          <Col xs={12} lg={10} xl={8}>
            <DriverDetailForm
              driver={driver}
              isEditMode={isEditMode}
              isEditFormSubmitting={isEditFormSubmitting}
              onEditFormSubmit={onEditFormSubmit}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default DriverDetail;
